import { Size } from "@brightagency/headstart-common";
import React, { useRef } from "react";
import { WPPost } from "../../../constants/types";
import { 
    // LocalListingPostTypeACF,
    ListingAcf } from "../../../constants/types/acf";
import { useBreakpoint } from "../../../controllers";
// import { getWpPostUrl } from "../../../utils";
import { ListingCard } from "../../molecules/ListingCard";
// import { PopulationCard } from "../../molecules/PopulationCard";
// import { Appearances } from "../../molecules/PopulationCard/styled";
import { Carousel, usePagedHorizontalScrolling } from "../Carousel";
import { CarouselSection } from "../CarouselSection";
interface Props {
    id: string;
    title: string;
    items: WPPost<ListingAcf>[];
}

export const FeaturedServices: React.FC<Props> = props => {
    const largeBreakpoint = useBreakpoint(Size.large, 50);
    const trackRef = useRef<HTMLDivElement>(null);
    const itemWidth = largeBreakpoint ? 256 : 256;
    const itemGutter = largeBreakpoint ? 16 : 8;
    const scrollAmount = itemWidth + itemGutter;
    const { scrollLeft, scrollRight, canScroll } = usePagedHorizontalScrolling({
        trackRef,
        pageWidth: scrollAmount,
        contentCount: props.items.length,
    });

    return (
        <CarouselSection
            id={props.id}
            title={props.title}
            carousel={{
                onScrollLeft: scrollLeft,
                onScrollRight: scrollRight,
                canScroll,
                displayControl: true,
                content: (
                    <Carousel scrollingRef={trackRef} itemWidth={itemWidth} itemGutter={itemGutter}>
                        {props.items.map(item => (
                            <ListingCard key={item.id} listing={item} compact={false} />
                        ))}
                    </Carousel>
                ),
            }}
        />
    );
};
